"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_AuditEvent_Network = exports.AuditEvent_NetworkTypeKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Element_1 = require("./RTTI_Element");
var AuditEvent_NetworkTypeKind;
(function (AuditEvent_NetworkTypeKind) {
    AuditEvent_NetworkTypeKind["_machineName"] = "1";
    AuditEvent_NetworkTypeKind["_ipAddress"] = "2";
    AuditEvent_NetworkTypeKind["_telephoneNumber"] = "3";
    AuditEvent_NetworkTypeKind["_emailAddress"] = "4";
    AuditEvent_NetworkTypeKind["_uri"] = "5";
})(AuditEvent_NetworkTypeKind = exports.AuditEvent_NetworkTypeKind || (exports.AuditEvent_NetworkTypeKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_AuditEvent_Network = t.recursion('IAuditEvent_Network', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        address: t.string,
        _address: RTTI_Element_1.RTTI_Element,
        type: (0, EnumType_1.createEnumType)(AuditEvent_NetworkTypeKind, 'AuditEvent_NetworkTypeKind'),
        _type: RTTI_Element_1.RTTI_Element
    });
});
//# sourceMappingURL=RTTI_AuditEvent_Network.js.map